{
  "$comment": "Esquema canónico do evento capturado. Secção 6.1 do documento de requisitos, mais as três colunas que os ADR 0009, 0010 e 0011 obrigam. É a FONTE ÚNICA: o validador em Go e o validador em TypeScript são gerados daqui, e não escritos duas vezes. Dois validadores escritos à mão divergem, e o sintoma é o SDK considerar válido o que a ingestão recusa.",
  "versao_protocolo": 1,
  "compatibilidade_meses": 24,
  "campos": [
    {
      "nome": "event_id",
      "tipo": "uuid",
      "obrigatorio": true,
      "nota": "Idempotência. A repetição é o funcionamento normal, porque o SDK reenvia"
    },
    {
      "nome": "project_id",
      "tipo": "uuid",
      "obrigatorio": true,
      "nota": "Identifica a aplicação e o ambiente. Chave de isolamento"
    },
    {
      "nome": "organization_id",
      "tipo": "uuid",
      "obrigatorio": true,
      "nota": "Para as vistas consolidadas"
    },
    {
      "nome": "anonymous_id",
      "tipo": "texto",
      "obrigatorio": true,
      "max": 128,
      "nota": "Gerado no dispositivo"
    },
    {
      "nome": "user_id",
      "tipo": "texto",
      "obrigatorio": false,
      "max": 128,
      "nota": "Pseudonimizado, depois da autenticação. NUNCA um identificador direto"
    },
    {
      "nome": "device_id",
      "tipo": "texto",
      "obrigatorio": true,
      "max": 128
    },
    {
      "nome": "session_id",
      "tipo": "texto",
      "obrigatorio": true,
      "max": 128,
      "nota": "Sessão técnica, não unidade de análise"
    },
    {
      "nome": "event_type",
      "tipo": "enum",
      "obrigatorio": true,
      "valores": [
        "ecra",
        "toque",
        "foco",
        "tecla",
        "desfoco",
        "submissao",
        "erro",
        "recuo",
        "plano_fundo",
        "erro_rede",
        "mensagem",
        "personalizado",
        "toque_sem_alvo",
        "toque_desativado",
        "toque_repetido",
        "toque_em_carregamento",
        "primeira_interacao",
        "deslocamento",
        "campo",
        "passo",
        "espera",
        "terminal",
        "ambiente"
      ],
      "nota": "Os dez do RF-CAP-04, mais mensagem e personalizado, mais os dez da captura granular do RF-GRA"
    },
    {
      "nome": "screen_key",
      "tipo": "texto",
      "obrigatorio": true,
      "max": 256
    },
    {
      "nome": "element_key",
      "tipo": "texto",
      "obrigatorio": false,
      "max": 512,
      "nota": "O tuplo de sinais do ADR 0003, serializado"
    },
    {
      "nome": "occurred_at",
      "tipo": "instante",
      "obrigatorio": true,
      "nota": "Hora do dispositivo. Nunca usada sozinha num cálculo"
    },
    {
      "nome": "received_at",
      "tipo": "instante",
      "obrigatorio": false,
      "nota": "Preenchido pela ingestão, e recusado se vier do cliente"
    },
    {
      "nome": "clock_offset_ms",
      "tipo": "inteiro",
      "obrigatorio": false,
      "min": -86400000,
      "max_valor": 86400000,
      "nota": "Desvio calculado. Fora de um dia é relógio partido"
    },
    {
      "nome": "app_version",
      "tipo": "texto",
      "obrigatorio": true,
      "max": 64
    },
    {
      "nome": "platform",
      "tipo": "enum",
      "obrigatorio": true,
      "valores": [
        "web",
        "android",
        "ios",
        "react_native",
        "flutter"
      ]
    },
    {
      "nome": "identity_scope",
      "tipo": "enum",
      "obrigatorio": true,
      "valores": [
        "aplicacao",
        "organizacao"
      ],
      "nota": "ADR 0011. Existe desde o primeiro evento, mesmo enquanto for sempre aplicacao"
    },
    {
      "nome": "capture_level",
      "tipo": "enum",
      "obrigatorio": true,
      "valores": [
        "essencial",
        "padrao",
        "detalhado"
      ],
      "nota": "ADR 0010. Sem ele, dois períodos com amostragem diferente comparam-se sem ninguém saber"
    },
    {
      "nome": "properties",
      "tipo": "objeto",
      "obrigatorio": false,
      "nota": "Definidas pelo cliente. NUNCA conteúdo de campos"
    },
    {
      "nome": "message_key",
      "tipo": "texto",
      "obrigatorio": false,
      "max": 256
    },
    {
      "nome": "message_kind",
      "tipo": "enum",
      "obrigatorio": false,
      "valores": [
        "erro",
        "aviso",
        "sucesso",
        "info"
      ]
    },
    {
      "nome": "message_text_masked",
      "tipo": "texto",
      "obrigatorio": false,
      "max": 1024,
      "nota": "Só quando não há chave. Chega já mascarado do dispositivo"
    },
    {
      "nome": "duration_ms",
      "tipo": "inteiro",
      "obrigatorio": false,
      "min": 0,
      "max_valor": 86400000
    },
    {
      "nome": "os_name",
      "tipo": "texto",
      "obrigatorio": false,
      "max": 32,
      "nota": "RF-MET-12. O nome do sistema operativo, tal como o dispositivo o diz: Android, iOS, Windows, macOS, Linux, ChromeOS. Serve para segmentar, e nunca para identificar"
    },
    {
      "nome": "os_version",
      "tipo": "texto",
      "obrigatorio": false,
      "max": 32,
      "nota": "Só a parte maior da versão. A versão completa de um sistema operativo é um sinal de impressão digital, e a segmentação não precisa dela"
    },
    {
      "nome": "device_class",
      "tipo": "enum",
      "obrigatorio": false,
      "valores": [
        "telemovel",
        "tablet",
        "computador",
        "desconhecido"
      ],
      "nota": "RF-MET-12. Três classes e não o modelo: o modelo identifica, a classe segmenta"
    },
    {
      "nome": "time_zone",
      "tipo": "texto",
      "obrigatorio": false,
      "max": 64,
      "nota": "A geografia deste produto, e é o fuso IANA do dispositivo (Europe/Lisbon). Nunca IP, nunca coordenadas, nunca permissão de localização. Ver o ADR 0022"
    }
  ],
  "regras": [
    {
      "codigo": "sem_conteudo",
      "descricao": "Nenhum campo transporta conteúdo escrito pelo utilizador. As properties são validadas contra uma lista de chaves permitidas, e os valores só podem ser número, booleano ou texto curto sem dígitos longos."
    },
    {
      "codigo": "mensagem_coerente",
      "descricao": "Um evento de tipo mensagem tem de trazer message_key ou message_text_masked, e message_kind."
    },
    {
      "codigo": "recebido_do_servidor",
      "descricao": "received_at é preenchido pela ingestão. Se vier do cliente, é ignorado e o evento é aceite na mesma."
    },
    {
      "codigo": "relogio_plausivel",
      "descricao": "clock_offset_ms fora de mais ou menos um dia é relógio partido, e o evento é rejeitado com motivo."
    },
    {
      "codigo": "mensagem_sem_conteudo",
      "descricao": "O message_text_masked chega já mascarado do dispositivo, e a ingestão volta a verificá-lo: correio electrónico, sequências longas de dígitos ou qualquer corrida de mais de quatro algarismos são recusadas. A mascaragem do dispositivo é a promessa; esta regra é a prova de que ela foi cumprida, e recusa em vez de mascarar porque mascarar aqui esconderia o defeito de quem enviou."
    },
    {
      "codigo": "propriedade_conhecida",
      "descricao": "Uma propriedade que não esteja em propriedades_permitidas é recusada, e não ignorada: um campo que passa em silêncio é um campo que ninguém percebe que está a ser deitado fora."
    },
    {
      "codigo": "fuso_e_nao_lugar",
      "descricao": "O time_zone é um fuso IANA (Europe/Lisbon), ou UTC. Coordenadas, cidades escritas à mão e qualquer coisa com dígitos decimais são recusadas: a geografia deste produto é grosseira por construção, e um campo que aceitasse um par de coordenadas seria a porta por onde a localização exata entrava. Ver o ADR 0022"
    },
    {
      "codigo": "identificador_e_chave_de_elemento",
      "descricao": "Uma propriedade de identificador aceita até 512 caracteres **quando tem a forma de uma chave de elemento** (contém `v1|f=`), e é dispensada da verificação de conteúdo, tal como o próprio campo `element_key`. Sem essa forma, volta a valer o limite de 64 caracteres e a regra `sem_conteudo`: a exceção é para o identificador que o SDK constrói, e não uma porta para texto livre comprido."
    }
  ],
  "propriedades_opacas": {
    "$comment": "Propriedades cujo valor é, por construção, um resumo calculado no dispositivo sobre texto já mascarado. A regra `sem_conteudo` recusa corridas de algarismos num valor de texto, e um resumo em hexadecimal tem-nas com frequência: `62431dbd` traz cinco algarismos seguidos e não traz informação nenhuma. Sem esta lista, a guarda que existe para impedir fugas recusava exatamente os valores que não podem transportar nenhuma.",
    "chaves": [
      "grupo_mensagem"
    ]
  },
  "propriedades_permitidas": {
    "$comment": "A lista vive aqui, e não dentro de cada validador. Estava escrita duas vezes, uma em Go e outra em TypeScript, e uma chave acrescentada de um lado só passava a ser recusada pelo outro sem ninguém dar por isso.",
    "negocio": {
      "$comment": "Definidas pelo cliente, para segmentar. NUNCA conteúdo de campos",
      "chaves": [
        "valor_monetario",
        "moeda",
        "tipo_utilizador",
        "segmento",
        "canal",
        "campanha",
        "experiencia"
      ]
    },
    "toque": {
      "$comment": "RF-GRA-01 a RF-GRA-05 e RF-IND-01 a RF-IND-03. As coordenadas vão em percentagem, e não em pixels: um mapa de calor tem de sobrepor telemóveis e computadores. São duas percentagens diferentes e é de propósito: `toque_x` é da janela, e é o que desenha o mapa; `alvo_x` é da caixa do elemento, e é o que diz se a pessoa acertou no meio do botão ou na beira dele. A `alvo_caixa` é a caixa do elemento na janela, e é dela que a reconstrução esquemática do ecrã se faz, sem nenhuma captura",
      "chaves": [
        "toque_x",
        "toque_y",
        "zona",
        "repeticoes",
        "intervalo_ms",
        "alvo_desativado",
        "em_carregamento",
        "alvo_x",
        "alvo_y",
        "alvo_caixa",
        "visor_largura",
        "visor_altura",
        "ordem_na_sequencia"
      ]
    },
    "campo": {
      "$comment": "RF-GRA-09 a RF-GRA-19. Contagens e tempos, nunca caracteres",
      "chaves": [
        "hesitacao_ms",
        "tempo_fundo_ms",
        "caracteres_escritos",
        "caracteres_apagados",
        "origem",
        "visitado_vazio",
        "regressos",
        "ordem",
        "ordem_prevista",
        "estado_na_submissao",
        "tentativas_ate_resolver",
        "fase"
      ]
    },
    "progressao": {
      "$comment": "RF-GRA-20 a RF-GRA-25",
      "chaves": [
        "passo",
        "passo_anterior",
        "estado",
        "campo_abandono",
        "mudanca",
        "valor",
        "campos_preenchidos",
        "campos_vazios",
        "campos_com_erro"
      ]
    },
    "mensagem": {
      "$comment": "RF-MSG. A chave e a classe vão em colunas próprias; aqui fica o resto do contexto. O grupo_mensagem é a chave de agrupamento por semelhança do RF-MSG-03: duas variantes da mesma mensagem têm chaves diferentes e o mesmo grupo",
      "chaves": [
        "origem_mensagem",
        "classe_erro",
        "codigo_http",
        "operacao",
        "visivel",
        "grupo_mensagem",
        "campo_associado"
      ]
    },
    "deslocamento": {
      "$comment": "RF-IND-05. A profundidade é a percentagem da página que chegou a estar visível, e o `alcance_ms` é quanto tempo demorou a lá chegar. Emite-se **uma vez por ecrã**, quando ele se fecha: um evento por deslocamento multiplicava o volume por cem e dizia a mesma coisa",
      "chaves": [
        "profundidade",
        "alcance_ms",
        "visor_altura"
      ]
    }
  },
  "propriedades_identificador": {
    "$comment": "Propriedades cujo valor é uma chave de elemento, e não texto. Uma chave de elemento é o tuplo de cinco sinais do ADR 0003 já serializado, e passa facilmente dos 64 caracteres que a regra `sem_conteudo` permite a um valor de propriedade. Sem esta lista, os dois SDK truncavam-na aos 64 e o campo do abandono deixava de corresponder ao campo que produziu os outros números: o RF-GRA-18, que o documento chama a informação mais accionável do conjunto, ficava com um identificador que não junta com nada. Aqui valem os mesmos 512 caracteres do campo `element_key`, e pela mesma razão.",
    "chaves": [
      "campo_abandono",
      "campo_associado"
    ]
  }
}
